import classes from './CustomPhoneInput.module.scss';
import { useState } from 'react';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import InputLabel from '../InputLabel/InputLabel';

const CustomPhoneInput = (props) => {
	const [value, setValue] = useState(props.value || null);



	return (
		<>
			<InputLabel
				text={props.label}
				// extraText={props.extraText}
				// error={props.error}
				// required={props.required}
				// color={labelColor}
			/>
			<PhoneInput
				onChange={(e) => {
					setValue(e);
					if (props.onChange) {
						props.onChange(e);
					}
				}}
				value={props.value}
				defaultCountry="HU"
				international
				countryCallingCodeEditable={false}
				className={`${classes.main} ${props.className}`}
				style={{ borderColor: '#CED4DA' }}
				readOnly={props.readOnly}
			/>
		</>
	);
};

export default CustomPhoneInput;
